import React from "react"
import Img from "react-cloudinary-lazy-image"

export default props => {
  return <Img {...props} />
}
